export default __webpack_public_path__ + "static/7-357744110ed7ee8735fe6e65c0be48eb.png";